import React, { useCallback, useEffect, useRef, useState } from "react";
import { Table } from "antd";
import "./homeIndexListing.scss";
import AreaLoader from "../../../../../../layout/components/loading/areaLoader";
import indexIcon from "../../../../../../assets/img/index.svg";
import NoData from "../../NoData";
import useDashboardHierarchy from "../../../../../../core/hooks/useDashboardHeirarchy";
import { viewTrackedItemChart } from "../../../../../../core/helpers/dasboardRoute";
import isActionAllowed from "../../../../../../core/authorization/userPermissions";
import { DASHBOARD_VIEWER, REPORT_CATEGORY_CARE_FINANCIALS, } from "../../../../../../core/constants/permissionConstants";
import { useHistory } from "react-router-dom";
const TABLE_HEADER_RESERVE_PX = 44;
function HomeIndexListing({ rows, loading }) {
    const tableWrapperRef = useRef(null);
    const [scrollY, setScrollY] = useState(120);
    const history = useHistory();
    const isDashboardViewAllowed = isActionAllowed([DASHBOARD_VIEWER]);
    const isFinancialViewAllowed = isActionAllowed([
        REPORT_CATEGORY_CARE_FINANCIALS,
    ]);
    const { isSinglSite, isSingleCompany, isSingleCompanyAndSite, CompanyByGroup, SiteByCompany, } = useDashboardHierarchy();
    const navigateToDashboard = useCallback((row, index) => {
        console.log("navigateToDashboard", row);
        if (row.id == null || row.companyId == null)
            return;
        viewTrackedItemChart(+row.id, {}, row.companyId, history, CompanyByGroup, SiteByCompany, isSingleCompanyAndSite, isSinglSite, isSingleCompany, isDashboardViewAllowed, isFinancialViewAllowed);
    }, [history, isDashboardViewAllowed, isFinancialViewAllowed]);
    useEffect(() => {
        const el = tableWrapperRef.current;
        if (!el)
            return;
        const syncBodyScroll = () => {
            const h = el.clientHeight;
            if (h <= TABLE_HEADER_RESERVE_PX)
                return;
            setScrollY(Math.max(64, h - TABLE_HEADER_RESERVE_PX));
        };
        const ro = new ResizeObserver(syncBodyScroll);
        ro.observe(el);
        syncBodyScroll();
        return () => ro.disconnect();
    }, [rows, loading]);
    const columns = [
        {
            title: "HOME NAME",
            dataIndex: "homeName",
            key: "homeName",
            render: (v) => React.createElement("span", { className: "home-name" }, v),
        },
        {
            title: "SCORE",
            dataIndex: "score",
            key: "score",
            align: "center",
            render: (v) => React.createElement("span", { className: "score" }, v),
        },
        {
            title: "CHANGE",
            dataIndex: "change",
            key: "change",
            align: "center",
            render: (v) => (React.createElement("span", { className: v.tone === "up-green" ? "change up" : "change down" }, v.text)),
        },
        {
            title: "TREND",
            dataIndex: "trend",
            key: "trend",
            align: "center",
            render: (v) => React.createElement("span", { className: "trend" }, v),
        },
        {
            title: "RATING",
            dataIndex: "rating",
            key: "rating",
            align: "center",
            render: (v) => (React.createElement("span", { className: `rating-pill ${v.variant}` }, v.label)),
        },
    ];
    return (React.createElement("div", { className: "home-index-listing" },
        React.createElement("div", { ref: tableWrapperRef, className: "home-index-table-wrapper" },
            loading && (React.createElement("div", { className: "home-index-overlay" },
                React.createElement(AreaLoader, { area: "composite-index", customStyle: { display: "block" }, isLandingPage: true }))),
            !loading && rows && (rows === null || rows === void 0 ? void 0 : rows.length) > 0 && (React.createElement(Table, { columns: columns, dataSource: rows, rowKey: (r, i) => i === null || i === void 0 ? void 0 : i.toString(), pagination: false, size: "small", className: "home-index-table", scroll: { y: scrollY }, onRow: (record, index) => ({
                    onClick: () => navigateToDashboard(record, index),
                }) })),
            !loading && (!rows || rows.length === 0) && (React.createElement("div", { style: { color: "white" }, className: "home-index-empty-state" },
                React.createElement(NoData, { message: "Index not available yet!", detail: "The RODA BI Index will appear once sufficient data is collected.", logo: indexIcon }))))));
}
export default HomeIndexListing;
